'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/exchanges`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'sid_bcard': 1,
        'sid_user': 11,
        'ex_location': '',
        'ex_location_detail': '',
        'ex_trigger': '',
        'ex_trigger_detail': '',
        'age': 10,
        'feature': '',
        'comment': '',
        'outer_introducer': {
          'id': 1,
          'dept': '公共情報事業本部',
          'full_name': '大森 圭介'
        },
        'inner_introducer': {
          'id': 10,
          'full_name': '山田 一郎'
        },
        'editable': '1',
        'exchanger_full_name': '山田 太郎',
        'formatted_exdate': '2018/01/01'
      }
    ],
    'pagination': {
      'page_count': 2,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 123,
      'limit': 100
    }
  })

  mockAxios.onGet(new RegExp(`/exchanges/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'sid_bcard': 1,
      'sid_user': 10,
      'ex_location': '',
      'ex_location_detail': '',
      'ex_trigger': '',
      'ex_trigger_detail': '',
      'age': 10,
      'feature': '',
      'comment': '',
      'judgment': '0',
      'outer_introducer': {
        'id': 1,
        'dept': '公共情報事業本部',
        'full_name': '大森 圭介'
      },
      'inner_introducer': {
        'id': 10,
        'full_name': '山田 一郎'
      },
      'editable': '1',
      'exchanger_full_name': '山田 一郎',
      'formatted_exdate': '2018/01/01'
    }
  })

  mockAxios.onPut(new RegExp(`/exchanges/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onGet(new RegExp(`/exchanges/\\d+`)).reply(200, {
  })

  // 削除
  mockAxios.onDelete(new RegExp(`/exchanges/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onDelete(new RegExp(`/exchanges/delete/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'person_deleted': true
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/exchangeRepositoryMock.js